// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'vant/lib/index.css'
import Vue from "vue";
import App from "./App";
import "./assets/css/css.css";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import router from "./router";
import axios from "../src/axios/index";
import vant from 'vant';
import locale from 'element-ui/lib/locale/lang/en'
import enUS from 'vant/es/locale/lang/en-US';
import VueMeta from 'vue-meta'
Vue.use(VueMeta)
Vue.use(vant)
// import "bootstrap";
import $ from "jquery";

import DateTimePicker from 'vue-vanilla-datetime-picker';

Vue.component('date-time-picker', DateTimePicker);
Vue.config.productionTip = false;
Vue.prototype.$axios = axios;
// Vue.prototype.baseUrl = "http://aidite.vzhengit.com";
Vue.prototype.baseUrl = document.location.origin;
Vue.prototype.$ = $;

Vue.use(ElementUI, { locale })
import { Locale } from 'vant';
// 引入英文语言包

Locale.use('en-US', enUS);
/* eslint-disable no-new */

new Vue({
  el: "#app",
  router,
  components: { App },
  template: "<App/>",
  mounted () {
    // You'll need this for renderAfterDocumentEvent.
    
    document.dispatchEvent(new Event('render1'))
    }
});



// WEBPACK FOOTER //
// ./src/main.js